import { TicketFilterRequest } from "callable-data-objects";
import Ticket from "callable-data-objects/dist/models/ticket/Ticket";
import Page from "callable-data-objects/dist/services/Page";
import React from "react";
import { Container, Pagination } from "semantic-ui-react";

type TicketPaginationProps = {
  tickets: Page<Ticket>;
  filter: TicketFilterRequest;
  setFilter: React.Dispatch<React.SetStateAction<TicketFilterRequest>>;
};

const TicketPagination = ({
  tickets,
  filter,
  setFilter,
}: TicketPaginationProps) => {
  return (
    <Container fluid textAlign='center'>
      {tickets && (
        <Pagination
          onPageChange={(event, data) => {
            if (data.activePage) {
              var page: number = +data.activePage;
              setFilter({ ...filter, page: page - 1 });
            }
          }}
          activePage={tickets.number + 1}
          totalPages={tickets.totalPages}
        />
      )}
    </Container>
  );
};

export default TicketPagination;
